import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { CheckoutService } from '../../../../../../checkout/checkout.service';

@Component({
    selector: 'app-checkout-price-calculation-summary',
    template: `
        <ul class="flow-step__summary" *ngIf="checkoutService.getCheckoutData() | async as cd">
            <li class="flow-step__summary-row">
                <span>
                    <span class="flow-step__summary-row-content bold">
                        {{ cd.product?.make }} {{ cd.product?.model }}
                    </span>
                    <span class="flow-step__summary-row-content text-small text-secondary">
                        {{ cd.product?.variant }}
                    </span>
                </span>
                <span class="flow-step__summary-row-content">
                    {{ cd.product?.grossPrice | defaultcurrency }}
                </span>
            </li>

            <li class="flow-step__summary-row ">
                <span>
                    <span class="flow-step__summary-row-content bold">
                        {{ 'generic.exchange_car' | translate }}
                    </span>
                    <span class="flow-step__summary-row-content text-small text-secondary" *ngIf="cd?.exchangeCar">
                        {{ cd.exchangeCar?.make }} {{ cd.exchangeCar?.model }}
                    </span>
                </span>
                <span class="flow-step__summary-row-content" [ngSwitch]="cd?.exchangeCar !== null">
                    <ng-container *ngSwitchCase="true">-{{ cd.exchangeCar?.price | defaultcurrency }}</ng-container>
                    <ng-container *ngSwitchCase="false">{{ 'loan.no_exchange_car_choosen' | translate }}</ng-container>
                </span>
            </li>

            <ng-container *ngIf="cd.exchangeCar?.price">
                <li class="flow-step__summary-row">
                    <span>
                        <span class="flow-step__summary-row-content bold">
                            {{ 'loan.outstanding_debt_in_exchange_car' | translate }}
                        </span>
                        <span class="flow-step__summary-row-content bold">{{ outstandingDebt | defaultcurrency }}</span>
                    </span>
                </li>
                <li class="flow-step__summary-row">
                    <app-debt-input (handleChange)="handleOutstandingDebt.emit($event)"></app-debt-input>
                </li>
            </ng-container>

            <li class="flow-step__summary-row last-item">
                <span>
                    <span class="flow-step__summary-row-content bold">
                        {{ priceTranslation || 'generic.price' | translate }}
                    </span>
                </span>
                <span class="flow-step__summary-row-content" [ngSwitch]="cd?.exchangeCar !== null">
                    <ng-container *ngSwitchCase="true">-{{ cd.exchangeCar?.price | defaultcurrency }}</ng-container>
                    <ng-container *ngSwitchCase="false">{{ loanAmount | defaultcurrency }}</ng-container>
                </span>
            </li>
        </ul>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckoutPriceCalculationSummaryComponent {
    @Input() loanAmount?: number;
    @Input() outstandingDebt?: number;
    @Input() priceTranslation?: string;
    @Output() handleOutstandingDebt = new EventEmitter();
    constructor(public checkoutService: CheckoutService) {}
}
